import Cookies from 'js-cookie';
import { getUsers } from '@/api/user';
import storage from '@/utils/storage';
import { aesEncrypt } from './other';

type IUserInfo = IUser.IResponse.IUserDetailInfo;
interface IAccountInfo {
  mobile: string;
  token: string;
  pw: string;
}
interface INotFoundUser {
  name: string;
}
interface IOptionStore {
  [key: string]: string;
}
let userStore: IOptionStore = {};
const pageInfo = {
  pageindex: 1,
  pagesize: 2500,
};
export let companyAllActiveUser: IUserInfo[] = [];

export const getStringFirstAndLast = (val: string): string => {
  let result: string = val.trim();
  if (result.length > 2) {
    const strArr: string[] = result.split('');
    const first = strArr.shift();
    const last = strArr.pop();
    result = `${first}${last}`;
  }
  return result.toLocaleUpperCase();
};

const accountKey = 'easypm_account';
const accountKeyToken = accountKey + '_token';
export const getAccount = (): IAccountInfo => {
  const {mobile, pw} = Cookies.getJSON(accountKey) || {mobile: '', pw: ''};
  const token = storage.localGet(accountKeyToken) || '';
  return {
    mobile,
    pw,
    token,
  };
};
export const setAccount = (data: IAccountInfo) => {
  Cookies.set(accountKey, {
    mobile: data.mobile,
    pw: data.pw,
  }, {expires: 1});
  storage.localSet(accountKeyToken, data.token);
};
export const removeAccount = () => {
  Cookies.remove(accountKey);
  storage.localRemove(accountKeyToken);
};
export const loginCallBack = (req: IAuthenticate.IRequest.ILogin, res: IAuthenticate.IResponse.IData) => {
  const saveData = {
    mobile: res.user.name,
    token: res.accessToken,
    pw: aesEncrypt(req.password),
  };
  setAccount(saveData);
};
export const getCompanyAllActiveUser = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    getUsers(pageInfo).then((res) => {
      companyAllActiveUser = res.data;
      checkUserData(res.data.length, pageInfo.pagesize);
      userStore = {};
      resolve(res.message);
    }).catch((err) => {
      reject(err.message);
    });
  });
};
const getMoreActiveUser = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    getUsers(pageInfo).then((res) => {
      companyAllActiveUser.push(...res.data);
      checkUserData(res.data.length, pageInfo.pagesize);
      resolve(res.message);
    }).catch((err) => {
      reject(err.message);
    });
  });
};

export const getCompanyActiveUserByName = (name: string): Promise<IUserInfo[]> => {
  return getCompanyActiveUser({name});
};
export const getCompanyActiveUser = (params: IUser.IRequest.IGetUser): Promise<IUserInfo[]> => {
  return new Promise((resolve, reject) => {
    getUsers({
      ...params,
      active: true,
    }).then((res) => {
      resolve(res.data);
    }).catch((err) => {
      reject(err.message);
    });
  });
};
export const getUserById = (userId: string): string => {
  if (userStore[userId]) {
    return userStore[userId];
  } else {
    const result = companyAllActiveUser.find((user) => user.id === userId);
    if (result) {
      userStore[userId] = result.name;
      return result.name;
    } else {
      return userId;
    }
  }
};
export const searchUsersByName = (searchVal: string): IUserInfo[] => {
  const re = new RegExp('^' + searchVal, 'i');
  const result = companyAllActiveUser.filter((user) => re.test(user.name));
  return result.slice(0, 20);
};
export const searchUsersById = (userId: string): IUserInfo[] => {
  const result = companyAllActiveUser.find((user) => userId === user.id);
  return result ? [result] : [];
};

// from https://blog.csdn.net/itbrand/article/details/109239620
export const regPhone = /^(\+86\-)?1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/;

const checkUserData = (dataLength: number, pagesize: number) => {
  if (dataLength === pagesize) {
    pageInfo.pageindex++;
    getMoreActiveUser();
  }
};
